import { useEffect, useRef } from "react";
import confetti from "canvas-confetti";

interface Props {
  trigger: boolean;
  won?: boolean;
}

const prefersReducedMotion = () =>
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const ConfettiCelebration = ({ trigger, won = true }: Props) => {
  const firedRef = useRef(false);

  useEffect(() => {
    if (!trigger || firedRef.current || prefersReducedMotion()) return;
    firedRef.current = true;

    if (won) {
      const end = Date.now() + 3000;
      const frame = () => {
        confetti({
          particleCount: 4,
          angle: 60,
          spread: 55,
          origin: { x: 0, y: 0.7 },
          colors: ["#4caf50", "#ffc107", "#ff5722", "#2196f3", "#e91e63"],
          zIndex: 1500,
        });
        confetti({
          particleCount: 4,
          angle: 120,
          spread: 55,
          origin: { x: 1, y: 0.7 },
          colors: ["#4caf50", "#ffc107", "#ff5722", "#2196f3", "#e91e63"],
          zIndex: 1500,
        });
        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      };
      frame();
    } else {
      confetti({
        particleCount: 40,
        spread: 90,
        origin: { x: 0.5, y: 0.4 },
        colors: ["#555", "#888", "#333"],
        gravity: 2.5,
        scalar: 1.5,
        drift: 0,
        ticks: 80,
        zIndex: 1500,
      });
    }

    return () => {
      confetti.reset();
    };
  }, [trigger, won]);

  useEffect(() => {
    if (!trigger) {
      firedRef.current = false;
    }
  }, [trigger]);

  return null;
};
